import React from "react";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  /** Visual error state. The Field wrapper sets this automatically when it
   *  receives an `error` prop, so consumers usually don't need to set it. */
  invalid?: boolean;
};

/**
 * Styled `<input>`. Picks up the design tokens for border, focus ring, radius,
 * font. Stays uncontrolled-friendly — pass any value/onChange/defaultValue
 * shape your existing state management uses.
 */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  function Input({ className, invalid, ...rest }, ref) {
    const cls = ["tb-input", invalid ? "tb-input-invalid" : "", className]
      .filter(Boolean)
      .join(" ");
    return <input ref={ref} className={cls} {...rest} />;
  },
);
